import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function OwnerRoute({ children }) {
  const { user } = useAuth();
  if (user && user.role === "staff") return <Navigate to="/dashboard" replace />;
  return children;
}
